export const formatDuration = (totalSeconds) => {
    if (!totalSeconds) return null
    const mins = Math.floor(totalSeconds / 60)
    const secs = Math.round(totalSeconds % 60)
    if (mins === 0) return `${secs} sec`
    if (secs === 0) return `${mins} min`
    return `${mins} min ${secs} sec`
}
